/* Layout enhancement only: all original controls, field names, previews and form handlers are retained. */
(() => {
  function enhance(root) {
    if (root.dataset.maisonLayoutReady) return;
    root.dataset.maisonLayoutReady = 'true';
    const form = root.querySelector('form[id^="AddToCartForm"]');
    if (!form) return;
    const document = root.ownerDocument;
    const make = (tag, className, text) => {
      const node = document.createElement(tag);
      node.className = className;
      if (text) node.textContent = text;
      return node;
    };
    // Move the existing nodes, preserving names, options, values and event listeners.
    form.querySelectorAll('input[id^="custom-name"]').forEach(input => {
      const suffix = input.id.slice('custom-name'.length);
      const nameField = input.closest('.product-form__input');
      const font = form.querySelector('#customFontSelect' + suffix) || form.querySelector('#custom-font' + suffix);
      let fontField = font?.closest('.product-form__input');
      if (nameField && font && !fontField && font.parentElement === nameField.parentElement) {
        const nameLabel = nameField.previousElementSibling;
        const fontLabel = font.previousElementSibling;
        if (nameLabel?.getAttribute('for') === input.id && fontLabel?.tagName === 'LABEL') {
          nameField.prepend(nameLabel);
          fontField = make('div', 'product-form__input');
          fontLabel.before(fontField);
          fontField.append(fontLabel, font);
        }
      }
      if (!nameField || !fontField || nameField.closest('.maison-name-font')) return;
      if (nameField === fontField) {
        const group = nameField;
        const nameLabel = group.querySelector('label[for="' + input.id + '"]');
        const fontLabel = font.previousElementSibling;
        if (!nameLabel || fontLabel?.tagName !== 'LABEL') return;
        const heading = make('p', 'maison-field-heading', root.dataset.maisonPersonalization || nameLabel.textContent);
        const fields = make('div', 'maison-name-font__fields');
        const nameBox = make('div', 'product-form__input');
        const fontBox = make('div', 'product-form__input');
        nameBox.append(nameLabel, input);
        fontBox.append(fontLabel, font);
        fields.append(nameBox, fontBox);
        group.classList.add('maison-name-font');
        group.append(heading, fields);
        return;
      }
      // The second mug keeps its original conditional wrapper and its enable/disable behavior.
      if (fontField.contains(nameField) && font.parentElement === fontField) {
        const fontLabel = font.previousElementSibling;
        if (fontLabel?.tagName !== 'LABEL') return;
        const box = make('div', 'product-form__input');
        fontLabel.before(box);
        box.append(fontLabel, font);
        fontField = box;
      }
      const sameParent = nameField.parentElement === fontField.parentElement;
      const toolbarFont = fontField.parentElement?.classList.contains('editor-toolbar') && fontField.parentElement.parentElement === nameField.parentElement;
      if (!sameParent && !toolbarFont) return;
      const group = make('div', 'maison-name-font');
      const heading = make('p', 'maison-field-heading');
      const nameLabel = nameField.querySelector('.form__label');
      heading.textContent = root.dataset.maisonPersonalization || nameLabel?.textContent || '';
      const fields = make('div', 'maison-name-font__fields');
      nameField.before(group);
      fields.append(nameField, fontField);
      group.append(heading, fields);
    });
    const message = form.querySelector('#custom-message')?.closest('.product-form__input');
    if (message && !message.closest('details')) {
      const details = make('details', 'maison-notes');
      const summary = make('summary', '', message.querySelector('label')?.textContent.trim());
      message.before(details);
      details.append(summary, message);
    }
    const submit = form.querySelector('button[type="submit"]');
    const assurance = form.querySelector('.atelier-order-assurance');
    if (submit && assurance) submit.after(assurance);
    const review = form.querySelector('[data-atelier-review]');
    if (review) review.open = true;
    const instructions = root.querySelector('.product__accordion');
    if (instructions) form.after(instructions);
    const numberSteps = () => {
      let number = 0;
      root.querySelectorAll('.product__info-container .product-form__input, .maison-name-font').forEach(group => {
        if (group.closest('.maison-name-font__fields') || group.closest('.maison-notes')) return;
        const label = group.querySelector(':scope > .form__label, :scope > legend, :scope > .maison-field-heading');
        if (!label) return;
        const hasControls = group.matches('.maison-name-font') || group.querySelector('input:not([type="hidden"]),select,#file-upload-container');
        if (!hasControls) return;
        let badge = label.querySelector('.maison-step-number');
        if (!badge) {
          badge = make('span', 'maison-step-number');
          badge.setAttribute('aria-hidden', 'true');
          label.prepend(badge);
          label.classList.add('maison-step-label');
        }
        const hidden = group.closest('[hidden],[style*="display: none"],[style*="display:none"]');
        badge.textContent = hidden ? '' : String(++number);
      });
    };
    numberSteps();
    root.addEventListener('change', numberSteps);
  }
  const init = () => document.querySelectorAll('.atelier-maison-product').forEach(enhance);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
